<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
<span class="status-marker" [ngStyle]="statusStyle()">{{ statusKey() | translate }}</span>
